<template>
  <div style="height: 100%">
    <div class="head-view">
      <img style="width:100%;" src="../assets/img/person_bg.png" />
      <div>
        <div class="card-view">
          <div class="space-between" style="height: 115px">
            <div class="person-info" style="padding-left: 23px;padding-bottom: 12px;">
              <div class="vertical-center" style="color:white;white-space: nowrap">
                <div style="color:white;font-size: 22px">{{ form.name }}</div>
                <img v-if="form.sex === '男'" style="width: 18px;height: 18px;margin-left: 7px"
                  src="../assets/img/sex_male.png" />
                <img v-else style="width: 18px;height: 18px;margin-left: 7px" src="../assets/img/sex_famale.png" />
                <div class="button-1">{{ form.vip }}</div>
              </div>
              <div class="space-between text-center" style="margin-top: 15px;padding-right: 10px">
                <div class="font-color-1">
                  <div style="font-size: 18px;font-weight: bold">{{ form.cardfee }}</div>
                  <div style="font-size: 9px">账户余额(元)</div>
                </div>
                <div class="font-color-1">
                  <div style="font-size: 18px;font-weight: bold">{{ form.score }}</div>
                  <div style="font-size: 9px">可用积分</div>
                </div>
              </div>

            </div>
            <div class="patient-info">
              <div id="qrcode" class="qrcode"></div>
            </div>
          </div>
          <div class="space-between" style="padding: 0 20px">
            <div class="vertical-center">
              <img style="width: 14px;height: 14px" src="../assets/img/tiaoxingma.png" />
              <div @click="viewDetail" style="color: #a4a4a4;margin-left: 11px">查看条形码</div>
            </div>
            <div style="color: #a4a4a4;font-size: 11px">病例号：{{ form.blh }}</div>
          </div>
        </div>
      </div>

    </div>

    <mt-popup popup-transition="popup-fade" v-model="popupVisible" position="center">
      <div class="discount-code">
        <div style="font-size: 14px;color:#999">条形码：</div>
        <div
          style="text-align: center;font-size: 20px;margin-top: 4px;font-family: 'Bold';color:#c3a567;font-weight: bold;position: relative;z-index: 1;margin-top: 10px">
          {{ form.blh }}
        </div>
        <div style="overflow-y: hidden;height: 80px;margin-top: -12px">
          <canvas id="barcode" class="barcode" ref="barcode" style="margin:0 auto;text-align: center"></canvas>
        </div>
        <!--<div id="canvas" class="canvas" ref="canvas"-->
        <!--style="margin:5px auto;text-align: center;padding-bottom: 15px"></div>-->
      </div>
    </mt-popup>
    <!--<div @click="toPage('/bindPatient')" class="space-between click-item">-->
    <!--<img src="../assets/img/member.png"/>-->
    <!--<div class="flex-1">会员绑定</div>-->
    <!--<img class="arrow_right" src="../assets/img/arrow_right.png">-->
    <!--</div>-->
    <div v-if="menuShow[0] == '1'" @click="toPage('/tiketGet')" class="space-between click-item">
      <img style="height: 18px" src="../assets/img/card.png" />
      <div class="flex-1">优惠券领取</div>
      <img class="arrow_right" src="../assets/img/arrow_right.png">
    </div>
    <div v-if="menuShow[1] == '1'" @click="toPage('/myTicket')" class="space-between click-item">
      <img style="height: 18px" src="../assets/img/card.png" />
      <div class="flex-1">我的优惠券</div>
      <img class="arrow_right" src="../assets/img/arrow_right.png">
    </div>
    <div v-if="menuShow[2] == '1'" @click="toPage('/chargeDetail')" class="space-between click-item">
      <img src="../assets/img/pay.png" />
      <div class="flex-1">支付查询</div>
      <img class="arrow_right" src="../assets/img/arrow_right.png">
    </div>
    <div v-if="menuShow[3] == '1'" @click="toPage('/caseSearch')" class="space-between click-item">
      <img src="../assets/img/date.png" />
      <div class="flex-1">病例查询</div>
      <img class="arrow_right" src="../assets/img/arrow_right.png">
    </div>
    <div v-if="menuShow[4] == '1'" @click="onSubAddMyself" class="space-between click-item">
      <img style="height: 16px" src="../assets/img/yuyue.png" />
      <div class="flex-1">我要预约</div>
      <img class="arrow_right" src="../assets/img/arrow_right.png">
    </div>
    <div v-if="menuShow[5] == '1'" @click="subscribe2" class="space-between click-item">
      <img style="height: 16px" src="../assets/img/yuyue.png" />
      <div class="flex-1">无号预约</div>
      <img class="arrow_right" src="../assets/img/arrow_right.png">
    </div>
    <div v-if="menuShow[6] == '1'" @click="toPage('/subscribeInfo')" class="space-between click-item">
      <img style="height: 16px" src="../assets/img/yuyue.png" />
      <div class="flex-1">预约信息</div>
      <img class="arrow_right" src="../assets/img/arrow_right.png">
    </div>
  </div>
</template>

<script>
import { Indicator, Toast } from 'mint-ui';
import QRCode from 'qrcodejs2';
import BarCode from 'jsbarcode';
import api from '../api';
import utils from '../common/utils';

export default {
  data() {
    return {
      YY_USER_ID: '',
      form: {
        blh: 'xxxxxxxx',
        cardfee: '0.00',
        name: 'XXX',
        score: '0',
        sex: '男',
        vip: '普通',
      },
      popupVisible: false,
      menuShow: ['0', '0', '0', '0', '0', '0', '0'],
    };
  },
  methods: {
    onSubAddMyself() {
      const query = this.$route.query
      let paramStr = ''
      Object.keys(query).forEach((key) => {
        paramStr += "&" + key + '=' + query[key]
      })
      if (this.$route.query.len) {
        window.location.href = `http://wx.kq120.com/yyhis/?zsbm=${this.$store.state.baseInfo.clientID
          }&blh=${this.form.blh}${paramStr}`;
      } else {
        this.toPage('/registSubscribe');
      }
    },
    onSubAddOther() {

    },
    toPage(path) {
      this.$router.push({
        path,
        query: {
          YY_USER_ID: this.$route.query.YY_USER_ID,
          openId: this.$route.query.openId || this.openId,
        },
      });
    },
    viewDetail(item) {
      const _this = this;
      Object.assign(this.form, item);
      this.popupVisible = true;
      // _this.initQrcode(this.form.blh);
      _this.initBarCode(this.form.blh);
    },
    subscribe2() {
      const query = this.$route.query
      let paramStr = ''
      Object.keys(query).forEach((key) => {
        paramStr += "&" + key + '=' + query[key]
      })
      if (query.len) {
        window.location.href = `http://wx.kq120.com/yyhis/?zsbm=${this.$store.state.baseInfo.clientID}${paramStr}`;
      } else {
        window.location.href = `http://wx.kq123.com/?type=newbespeak&c=${this.$store.state.baseInfo.clientID}`;
      }
    },
    loadPartnerInfo(clientId, openId) {
      const _this = this;
      const url = `http://app.kq123.com/QSYYAPI/api/wx/vip?mzid=${clientId}&openid=${openId}`;
      Indicator.open('加载中...');

      api.get(_this, url, {
        mzid: clientId,
        openid: openId,
      }, (res) => {
        Indicator.close();
        console.log(res.data.Data);
        Object.assign(_this.form, res.data.Data);
        new QRCode('qrcode', {
          width: 80,
          height: 80,
          text: res.data.Data.blh, // 二维码地址
          colorDark: '#000',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.H,
        });
      }, (err) => {
        //                    Toast("网络出错，请稍后再试");
        Indicator.close();
      });
    },
    loadUserCenterMenu() {
      Indicator.open('加载中...');
      api.getFormUrl(this, this.$api.getUserCenterMenu, null, (res) => {
        console.log(res);
        this.menuShow = res.split('');
      }, () => {
        Indicator.close();
      });
    },
    initQrcode(code) {
      this.$refs.canvas.innerHTML = '';
      new QRCode('canvas', {
        width: 128,
        height: 128,
        text: code, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    initBarCode(code) {
      console.log(code);
      BarCode('#barcode', code, {
        // format: "CODE39",//选择要使用的条形码类型
        width: 2.0, // 设置条之间的宽度
        height: 50, // 高度
        displayValue: true, // 是否在条形码下方显示文字
        text: '', // 覆盖显示的文本
        // fontOptions:"bold italic",//使文字加粗体或变斜体
        font: '0', // 设置文本的字体
        color: '#c3a567',
        textAlign: 'center', // 设置文本的水平对齐方式
        textPosition: 'bottom', // 设置文本的垂直位置
        background: '#fff', // 设置条形码的背景
        lineColor: '#111', // 设置条和文本的颜色。
        textMargin: 5, // 设置条形码和文本之间的间距
        fontSize: 20, // 设置文本的大小
        margin: 15, // 设置条形码周围的空白边距
      });
    },
  },
  mounted() {
    const _this = this;
    const YY_USER_ID = this.$route.query.YY_USER_ID || '';
    if (YY_USER_ID) {
      this.YY_USER_ID = YY_USER_ID;
      this.$store.commit('set', {
        YY_USER_ID,
      });
    }
    utils.doIF(() => {
      //                if(_this.hasBind)
      _this.loadPartnerInfo(this.$store.state.baseInfo.clientID, this.$route.query.openId);
      _this.loadUserCenterMenu();
    }, () => this.$store.state.baseInfo && this.$route.query.openId);
  },
};

</script>

<style lang="scss">
@import "../assets/styles/common.css";

.page {
  height: 100%;
  overflow: hidden;
  position: relative;
  background: #eaeaea
}

.head-view {
  width: 100%;
  position: relative;
}

.card-view {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 20px;
}

.person-info {
  flex: 1;
}

.patient-info {
  padding: 10px 0 4px 0;
}

.qrcode {
  width: 106px;
  height: 106px;
  margin: 0 15px;
  padding: 7px 10px 2px 10px;
  box-sizing: border-box;
}

.font-color-1 {
  color: #ffe0b0;
}

.button-1 {
  color: #5a4a31;
  margin-left: 7px;
  padding: 3px 11px;
  background-size: cover;
  text-align: center;
  border-radius: 100px;
  background: linear-gradient(45deg, #a1a1a1, #ebebeb);
}

.click-item {
  background: white;
  height: 50px;
  font-size: 14px;

  img {
    width: 16px;
    height: 14px;
    margin-right: 12px;
    margin-left: 16px;
  }
}

.click-item:not(:last-child) {
  border-bottom: 1px solid #efefef;
}

.arrow_right {
  width: 12px;
  height: 18px;
}

.discount-code {
  left: 5rem;
  right: 5rem;
  padding: 8px 15px;
  min-width: 20rem;
}

.canvas>* {
  margin: auto;
  display: block;
}
</style>
